export enum SachetType {
  CG = 'Cowgenuss',
  GS = 'Gockelspeis',
  RT = 'Ringeltanz',
  WS = 'Wildschmaus', // TODO(WS): confirm brand name.
}

export enum SubscriptionError {
  FLOW_BANNER_NOT_FOUND = 'FLOW_BANNER_NOT_FOUND',
}
